import { render, staticRenderFns } from "./TitleCardIcon.vue?vue&type=template&id=28bbf226&"
import script from "./TitleCardIcon.vue?vue&type=script&lang=js&"
export * from "./TitleCardIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports